// Constants
import CONST_ATTENDANCE from 'constants/attendance';

// Helpers
import { getAttendantUsername, getUserType } from 'helpers/auth';
import { getStorageWebUserData } from 'helpers/webUser';

// The username sent on attendantPublish frames is persisted with each message
// and displayed verbatim in the passenger app, so it must be the person's
// name — never a role. Used by both the text (Form) and file (saga) sends.
export const getSenderDisplayName = (): string => {
  if (getUserType() === CONST_ATTENDANCE.USER_TYPES.ATTENDANT) {
    const attendantName = getAttendantUsername();
    if (attendantName) return attendantName;
  }

  // Supervisors: the logged web user's name — same source the header uses
  try {
    const { name } = JSON.parse(getStorageWebUserData());
    if (name) return name;
  } catch (e) {
    // malformed storage — fall back to the generic label below
  }

  return 'Supervisor';
};

export default getSenderDisplayName;
